var ajaxcontent = function() {

  var $contact_list = $('.contact-list>div');
  if ($contact_list.length) {
      ddLog('Using contact_list in ajax.js');
      // Contact Page Contact Links
      getEventsByType()
          .done(function(data) {

              var output = `<option id="none_selected">&mdash; ${_pleaseselect} &mdash;</option>`;

              $.each( data, function( eventTypeKey, eventType ) {
                  $.each( eventType.events, function( eventKey, event ) {
                      var eventContactURL = event.contact ? event.contact : event.url + 'contact-us';
                      output += `<option class="new_window" id="contact_id_${event.code}" value="${eventContactURL}">${event.title_label}</option>`;
                  });
              });

              $contact_list.html(`<select id='select_contacts' style='font-size:18px; padding:5px; border-box:content-box'>${output}</select>`);
          });
  }


  // Home AfterMovies
  var $aftermovies = $('div.globalumftv');
  if ( !!$aftermovies.length ) {
      ddLog('Using aftermovies in ajax.js');
      //$aftermovies.hide();
      $.get( ultra_settings.endpoints.aftermovies_url, function() {})
          .done(function(data) {
              var output = '';

              $.each( data, function( key, val ) {
                  var image = val.image;
                  var title = val.title;
                  var video_id = val.video_id;
                  var bgclass = 'bg-contain';
                  // HTML Output
                  if ( $('.col2-vids-news').length || $('.col2-vids-artists').length ) {
                      bgclass = 'bg-cover';
                  }
                  output += `<li><a data-fancybox=videos href="https://www.youtube.com/embed/${video_id}?autoplay=1" class="${bgclass}" title="${title}" style="background-image: url(${image}); background-position: 50% 50%; background-repeat: no-repeat;"><strong class="bg80">${title}</strong> <img src="${image}" alt="" class="rspv"><span class="vid-icon"></span></a></li>`;
              });
              $aftermovies.find('ul')
                  .html(output)
                  .cycle();
          })
  }

  // Home News
  $('div.newspress ul').cycle();

   // Home Artists
   $('div.artists-home-list ul')
       .on( 'cycle-before', function(event, optionHash, outgoingSlideEl, incomingSlideEl, forwardFlag) {

           if ($('div.artist-pager span:nth-child(n+0)').hasClass('cycle-pager-active')) {
               $('div.artist-pager span').css({'position' : 'relative', 'top' : '0px'});
           }
           if ($('div.artist-pager span:nth-child(n+13)').hasClass('cycle-pager-active')) {
               $('div.artist-pager span').css({'position' : 'relative', 'top' : '-24px'});
           }
           if ($('div.artist-pager span:nth-child(n+26)').hasClass('cycle-pager-active')) {
               $('div.artist-pager span').css({'position' : 'relative', 'top' : '-50px'});
           }

       })
       .on( 'cycle-after', function(event, optionHash, outgoingSlideEl, incomingSlideEl, forwardFlag) {

           if ($('div.artist-pager span:nth-child(n+1)').hasClass('cycle-pager-active')) {
               $('div.artist-pager span').css({'position' : 'relative', 'top' : '0px'});
           }
           if ($('div.artist-pager span:nth-child(n+14)').hasClass('cycle-pager-active')) {
               $('div.artist-pager span').css({'position' : 'relative', 'top' : '-24px'});
           }
           if ($('div.artist-pager span:nth-child(n+27)').hasClass('cycle-pager-active')) {
               $('div.artist-pager span').css({'position' : 'relative', 'top' : '-50px'});
           }

       })
       .cycle();



  // Banners Global
  if ( !!$('div.ad-banners').length ) {
      ddLog('Using ad-banners in ajax.js');

      //$('div.ad-banners').hide();
      $.get( ultra_settings.endpoints.banners_url, function() {})
      .done(function(data) {

          var output = '';

          $.each( data, function( key, val ) {

              output += '<li>';
              output += '<a target="_blank"';
              if( val.link_url != '') {
                  output += `href="${val.link_url}" >`;
              } else {
                  output += '>';
              }
              if( val.banner != '') {
                  var banner_url = val.banner.replace("http:", "https:");
                  output += `<img src="${banner_url}" alt="${val.title}" width="850">`;
              }

              output += '</a></li>';

          })

          $('div.ad-banners>ul').append(output);

      })
      .always(function() {
          $('div.ad-banners ul').cycle();
          //$('div.ad-banners').fadeIn(300);
      })

  }

  // Artists Home
    var $artistList = $('ul.artists-list li');9
    if (!!$artistList.length) {
        ddLog('Using artistList in ajax.js');
        //TODO: This should happen server-side
        $.getJSON(ultra_settings.endpoints.artists_url)
            .done(function (artists) {
                $.each($artistList, function (key, val) {
                    var $this = $(this);
                    var id = $(val).data('id');

                    var artist = _.find(artists, {'slug': id});

                    if (artist && artist.image == null && artist.logo) {
                        $("<img/>", {
                            load: function () {
                                var imgclass = (this.width > this.height) ? 'wide' : 'tall';

                                $this.find('img').addClass('alogobg');
                                $this.find('img').after(`<span class="alogo"></span><img src="${this.src}" class="alogo ${imgclass}">`);
                            },
                            src: artist.logo
                        });
                    }
                }) // End Artist
            }) // End Done
    }

  // News Home
  var $newsList = $('div.news-home .post-entry');
  if ( !!$newsList.length ) {

      ddLog('Using newsList in ajax.js');

      $.get( ultra_settings.endpoints.news_url, function() {})
      .done(function(data) {
          var output = '';

          var newsItems = $newsList.find('article');
          $.each( newsItems, function(key, val) {
              $this = $(this);
              var id = $(val).data('id');
              var permalink = $(val).data('link');

              $.each( data, function( key, val ) {
                  var post_name = val.post.post_name;
                  if (id == post_name) {
                      var custom_excerpt = val.meta.custom_excerpt;
                      var custom_thumbnail = val.meta.custom_thumbnail;
                      var featured_image = val.meta.featured_image;
                      var featured_image_alt = val.meta.featured_image_alt;
                      var hide_thumbnail = val.meta.hide_thumbnail;
                      var embedded_media = val.meta.embedded_media;
                      var youtube_video_id = val.meta.youtube_video_id;
                      var embed_code = val.meta.embed_code;
                      var show_thumbnail_on_post = val.meta.show_thumbnail_on_post;
                      var show_thumbnail_on_list = val.meta.show_thumbnail_on_list;

                      var embed = '';
                      var output = '';

                      $this.find('div.custom_excerpt_ww').html(custom_excerpt);

                      // Set embed code
                      if (embedded_media == 'YouTube') {
                          embed = `<iframe width="853" height="480" src="https://www.youtube.com/embed/${youtube_video_id}?rel=0" frameborder="0" allowfullscreen></iframe>`;
                      } else {
                          embed = embed_code;
                      }

                      // Now the vars are set, let's update html
                      if (embed) {
                          output = '<div class="padb25"><div class="vid-wrap">'+embed+'</div></div>'
                      } else {
                          // If there is a custom thumbnail use it on the list view, otherwise never use custom thumbnail
                          // If Featured image only, then use it, else use default
                          featured_image = custom_thumbnail || featured_image || ultra_settings.image.default_placeholder;
                          featured_image = featured_image.replace("http:", "https:");
                          output = `<div class="padb25"><a href="${permalink}" class="alink" title="${post_name}"> <img src="${featured_image}" alt="${featured_image_alt}"> </a></div>`;
                      }

                      $this.find('div.news-json-featured').html(output);
                      //writeVideos();
                      embedded_media = '';
                      output = '';
                  }
              }) // End JSON
          }) // End Artist
      }) // End Done
      .always(function() {
          setTimeout(function(){
              $('.artists-list span.loader').fadeOut();
          }, 1200)
      })
  }

  // TODO: What does this even do?
  // Single Artist Header
  /*var artistHeader = $('div.artist-header');
  if ( !!artistHeader.length ) {
      ddLog('Using artistHeader in ajax.js');
      getEventJSON()
      .done(function(data) {

          var output = '';

          var artistsItems = artistHeader.find('span');

          $.each( artistsItems, function(key, val) {

              $this = $(this);
              var id = $(val).data('event');

              $.each( data, function( key, val ) {

                  var event_title = val.title;
                  event_title = event_title.replace("h—", "h ");
                  var event_name = event_title;
                  event_name = event_name.toLowerCase();
                  event_name = event_name.replace(" ", "-");
                  var event_date = val.date.label;
                  event_date = event_date.replace(" —", "");
                  event_date = event_date.replace("2016", "");
                  //event_date = event_date.replace(".", "");

                  if (id == event_name) {
                      if (id == 'south-africa') {
                          //event_date = event_date.replace("26, 27, 28", "27<span class='thin darkspacer'> - </span>28, ");
                          var sadate = '27, Feb. &nbsp;&nbsp;<span class="thin darkspacer">/</span>&nbsp;&nbsp; Johannesburg<br>28, Feb. &nbsp;&nbsp;<span class="thin darkspacer">/</span>&nbsp;&nbsp;  Cape Town';
                          $('span.'+event_name).html(sadate);
                      }
                      if (id == 'miami') {
                          event_date = event_date.replace("18, 19, 20", "18 <span class='darkspacer'>&ndash;</span> 20, ");
                          $('span.'+event_name).html(event_date+' &nbsp;&nbsp;<span class="thin darkspacer">/</span>&nbsp;&nbsp; '+event_title);
                      }
                  }
              }) // End JSON
          }) // End Artist
      }) // End Done
  }*/

  // Artist Single
  var artistPage = $('div#single-artist');

    if (!!artistPage.length) {
        ddLog('Using artistPage in ajax.js');
        //TODO: This should happen server-side

        var artistSlug = artistPage.data('slug');
        var artistURL = `https://artists.ultramusicfestival.com/artist/${artistSlug}/`;
        var output = '';

        //artistPage.fadeTo(300, .01);

        $.get(artistURL).done(artist => {
            var vidurl = '';

            var umfradio = $('#umfradiosite').length;

            // Video
            if (!umfradio && (artist.videoid || artist.beattvid)) {
                if (artist.beattvid) {
                    artist.beattvid = artist.beattvid.replace("http:", "https:");
                    vidurl = `${artist.beattvid}.frame`;
                }
                else {
                    vidurl = `https://www.youtube.com/embed/${artist.videoid}`; //?autoplay=1
                }

                output += `
                    <a href="${vidurl}?autoplay=1" data-fancybox="videos" >&nbsp;</a>
                    <div class="vid-wrap mb25">
                        <iframe width="640" height="360" src="${vidurl}" frameborder="0" allowfullscreen=""></iframe>
                    </div>`;

            }
            else if (artist.image) {
                    output += `
                        <a href="${artist.image}" class="padt25 block padb25" data-fancybox="gallery" title="${artist.title}">
                            <img src="${artist.image}" alt="${artist.title}" class="rspv">
                        </a>`;
            }

            if (artist.playlist) {
                output += `
                    <div class="rs100 mb25">
                        <iframe width="100%" height="500" src="${artist.playlist}&at=1001lu96" frameborder="0" allowfullscreen=""></iframe>
                    </div>`;
            }
            else if (artist.audio) {
                output += `
                    <div class="rs100 mb25">
                        <iframe width="100%" height="110" src="${artist.audio}" frameborder="0" allowfullscreen=""></iframe>
                    </div>`;
            }

            // Social
            const socialMappings = {
                'website': { icon: 'fas fa-globe', prefix: '', name: 'Website' },
                'facebook': { icon: 'fab fa-facebook', prefix: 'https://www.facebook.com/', name: 'Facebook' },
                'twitter': { icon: 'fab fa-x-twitter', prefix: 'https://www.twitter.com/', name: 'Twitter' },
                'instagram': { icon: 'fab fa-instagram', prefix: 'https://instagram.com/', name: 'Instagram' },
                'youtube': { icon: 'fab fa-youtube', prefix: 'https://www.youtube.com/', name: 'YouTube' },
                'soundcloud': { icon: 'fab fa-soundcloud', prefix: 'https://soundcloud.com/', name: 'Soundcloud' },
                'apple_music': { icon: 'fab fa-apple', prefix: '', name: 'Apple Music' },
                'spotify': { icon: 'fab fa-spotify', prefix: '', name: 'Spotify' }
            };

            output += '</div><ul class="social clearfix mb25">';

            for (const key in socialMappings) {
                if (socialMappings.hasOwnProperty(key) && artist[key]) {
                    const { icon, prefix, name } = socialMappings[key];
                    output += `<li><a href="${prefix}${artist[key]}" title="${artist.title}'s ${name}" target="_blank"><span class="${icon}"></span></a></li>`;
                }
            }

            output += '</ul>';

            // Image for responsive
            if (artist.image && (!umfradio || (!artist.videoid && !artist.beattvid))) {
                output += `
                    <a href="${artist.image}" data-fancybox="gallery" class="padt25 desk-hide" title="${artist.title}">
                        <img src="${artist.image}" alt="${artist.title}" class="rspv">
                    </a>`;
                $('article.type-artist a.desk-hide').remove();
            }

            $('.ac', artistPage).html(output);
            //artistPage.delay(500).fadeTo(1000, 1);
            artistPage.delay(1000).css('opacity', 1);
        })
    }

    wwGlobal();
};


function fillEvents() {
    var $participatingFestivals = $('div#participating-festivals');
    var $participatingEvents = $('div#participating-events');

    if ( $participatingFestivals.length || $participatingEvents.length ) {
        ddLog('Using fillEvents in ajax.js');
        getEventsByType()
        .done(function(data) {
            var eventLinks = [];
            $.each(data, function (eventTypeKey, eventType) {
                eventLinks[eventTypeKey] = '';
                $.each(eventType.events, function (eventKey, event) {
                    if (event.visibility.points) {
                        var flag = '';
                        if (event.media.flag) {
                            flag = `<img src="${event.media.flag}">`;
                        }
                        eventLinks[eventTypeKey] += `<li><a href="${event.url}" target="_blank">${flag} ${event.title_label_short}</a></li>`;
                    }
                });
            });

            var finaloutput = `
            <div class="mleft">
                <div class="egroup">
                    <h2><img src="${ultra_settings.event_types.rtu.logo}"></h2>
                    <hr class="rtu">
                    <ul class="elist">${eventLinks['rtu']}</ul>
                </div>
                <div class="egroup beach">
                    <h2><img src="${ultra_settings.event_types.beach.logo}"></h2>
                    <hr class="beach">
                    <ul class="elist">${eventLinks['beach']}</ul>
                </div>
            </div>
            <div class="egroup resistance">
                <h2><img src="${ultra_settings.event_types.resistance.logo}"></h2>
                <hr class="resistance">
                <ul class="elist">${eventLinks['resistance']}</ul>
            </div>`;

            $participatingFestivals.html(`<ul class="elist">${eventLinks['ultra']}</ul>`);
            $participatingEvents.html(finaloutput);
        });
    }
}
